import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

import Link from 'components/common/A'

export const OneLineGrid = styled(Grid)`
  height: ${({ $height }) => $height || '72px'};
  width: ${({ $width }) => $width};
  overflow-y: hidden;
`

const StyledButton = styled(Button)`
  ${({ theme, size, shape }) => `
    border-radius: 25px;
    font-size: 14px;
    color: ${theme.palette.text.minus2};
    background: ${theme.palette.grey.third};
    padding: ${
      {
        sm: '10px 12px',
        md: '10px 16px',
        lg: '12px 20px',
        xl: '12px 20px',
      }[size]
    };
    border-radius: ${
      {
        round: '20px',
        rectangle: '6px',
      }[shape]
    }

    &:hover {
      background-color: ${theme.palette.primary.bgPlus1};
      box-shadow: none; // shadow override worked here only in ios browser
    }
    &:active {
      background-color: ${theme.palette.primary.main};
      color: #ffffff;
    }
  `}
`

const TagButton = ({
  href,
  children,
  shape = 'round',
  size = 'md',
  ...rest
}) => {
  return (
    <Link href={href || ''} $origin {...rest}>
      <StyledButton variant="contained" color="grey" shape={shape} size={size}>
        <Typography
          sx={{
            typography: {
              sm: 'bodyXs',
              md: 'bodySmall',
              lg: 'bodyMedium',
              xl: 'bodyLarge',
            }[size],
          }}
        >
          {children}
        </Typography>
      </StyledButton>
    </Link>
  )
}

export default TagButton
